import { path } from 'ramda';

export const selectFirstGraphQLErrorMetaMessage = path([
  'graphQLErrors',
  '0',
  'message',
]);
